import React, { useState } from "react";
import { url } from "../settings";

// Dependencies

//Components

// Styles
import styled from "styled-components";
import { grayscale, blue } from "../Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fontWeight } from "../Cytoplasm";
import { faStopwatch } from "@fortawesome/pro-duotone-svg-icons";

export default function MonthlyCyclesTutorial(props) {
  const { user, dismissed, setMonthlyCyclesTutorial } = props;

  function dismissNotification() {
    setVisible(false);
    setMonthlyCyclesTutorial(true)
    return fetch(`${url}/rounds/dismiss-notification/`, {
      method: "post",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        userId: user.id,
        notification: "monthly_cycles_tutorial",
      }),
    }).then((response) => {
      return response;
    });
  }

  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  if (dismissed) return null;

  return (
    <TutorialContainer>
      <FontAwesomeIcon icon={faStopwatch} size="6x" />
      <div className="big-text">New Encounters Every Week</div>
      <div className="text">
        New encounters will be added to your waiting room on a weekly basis.
        So be sure to check-in on your clinic frequently.
      </div>
      <div className="confirm" onClick={() => dismissNotification()}>
        Dismiss
      </div>
    </TutorialContainer>
  );;
}
const TutorialContainer = styled.div`
  padding: 25px;
  margin-top: 35px;
  background-color: ${grayscale.lightGray};
  text-align: center;
  .text {
    font-size: 18px;
    max-width: 500px;
    margin: auto;
    margin-top: 15px;
  }
  .big-text {
    font-size: 28px;
    font-weight: 700;
    margin-top: 20px;
  }
  .confirm {
    padding: 8px 10px;
    border-radius: 5px;
    background-color: ${grayscale.gray};
    color: ${blue.bright};
    max-width: fit-content;
    margin: auto;
    margin-top: 25px;
    cursor: pointer;
    font-weight: ${fontWeight.bold};
    &:hover {
      background-color: ${grayscale.gray};
    }
  }
`;
